import { Component } from '@angular/core';
import { Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { User } from 'src/app/modules/users/_types/user';
import { ContractProcessorsService } from 'src/app/modules/companies/_services/contracts-processors.service';
import { LocalStorageService } from 'angular-web-storage';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-processor',
    templateUrl: './processor.component.html',
    styleUrls: ['./processor.component.scss'],
    standalone: false
})
export class CasesDetailProcessorComponent {
  public processors: User[] = [];
  public selectedProcessor: any;
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    userType: new OrFilter([
          new Filter(FilterOperation.equals, 'userType.code', '', 'processor'),
          new Filter(FilterOperation.equals, 'id', '', this.storage.get('user')?.id)
        ]),
        id: new Filter(FilterOperation.any, 'id', '')
  };

  public currentUser: User | null = null;

  constructor(
    private usersService: UsersService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private storage: LocalStorageService,
    private contractProcessorsService: ContractProcessorsService,
    public loginService: LoginService
  ) { }

  async ngOnInit() {
    
    this.currentUser = this.storage.get('user') as User;
    let id = this.config.data.id;
    if (id != null && id != '0') {
      this.selectedProcessor = await firstValueFrom(this.usersService.get(id));
    }
  }

  async loadProcessors($event: any){
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

  
      // filtrar solo tramitadores
      /*let filters: any = {
        userType: new OrFilter([
          new Filter(FilterOperation.equals, 'userType.code', '', 'processor'),
          new Filter(FilterOperation.equals, 'id', '', this.currentUser?.id)
        ]),
        id: new Filter(FilterOperation.any, 'id', '')
      };*/
  
      //lista de tramitadores. Irán filtrados por su permiso
      //con CASES.ASSIGN_ANY_PROCESSOR se listan todos los tramitadores, tambien los de otros equipos.
      //Sin el permiso solo salen los del equipo: los que comparten contrato con el usuario. Esto es solo
      //de este popup; el desplegable "Tramitador" de la cabecera muestra siempre los del equipo.
      if(this.loginService.hasPermission('CASES.ASSIGN_ANY_PROCESSOR')){
        //creamos filtros
        params.filter = FilterBuilder.fromObject(this.filters).build();  
        let response = await firstValueFrom(this.usersService.all(params));
        this.processors = response.data;
        this.totalRecords = response.meta['total'];
      }else{
        //obtienes los contratos donde el usuario es tramitador.
        let filters2 = {
          processorId: new Filter(FilterOperation.equals, 'processorId', "", this.currentUser?.id)
        };  
        let params2: IParamsCollection = { page: { number: 1, size: 2000}}
        //creamos filtros
        params2.filter = FilterBuilder.fromObject(filters2).build();
        var contractProcessors = await firstValueFrom(this.contractProcessorsService.all(params2)).then(response => response.data);
        var contractsIds = contractProcessors.filter((v, i, a) => a.findIndex(t => (t.contractId === v.contractId)) === i).map(cp => cp.contractId);
  
        //los tramitadores de los mismos contratos que el usuario
        let filtersCases = {
          contractId: new Filter(FilterOperation.any, 'contractId', "", contractsIds)        
        };  
        let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
        //creamos filtros
        paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
        var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
        var contractProcessorsAllIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);
 
  
        //añadimos a el mismo
        contractProcessorsAllIds.push(this.currentUser?.id!);
        if(this.selectedProcessor)  contractProcessorsAllIds.push(this.selectedProcessor.id); //añadimos el tramitador del caso, aunque no forme parte de los contratos del usuario logueado.
  
        //filtramos por los usuarios que forman parte de los mismos contratos que el usuario logueado.
        this.filters.id = new Filter(FilterOperation.any, 'id', '', contractProcessorsAllIds);
        params.filter = FilterBuilder.fromObject(this.filters).build();  
        let response = await firstValueFrom(this.usersService.all(params));
        this.processors = response.data;
        this.totalRecords = response.meta['total'];

      }
    }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadProcessors(this.lastGridEvent);
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  save() {
    this.dynamicDialogRef.close(this.selectedProcessor);
  }

}
